import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="kategorie-produktow" className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-wider mb-2">
            Kategorie produktów
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
            Przeglądaj kategorie
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-md mx-auto">
            Odkryj szeroki wybór produktów dostępnych na platformie usfansspreadsheet
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-300/60 hover:translate-y-[-2px] transition-all duration-300 cursor-pointer overflow-hidden"
            >
              {/* Category Image */}
              <div className="w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.namePl}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              {/* Label */}
              <div className="flex items-center gap-2 px-3 pb-4">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-sm text-accent-600`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors">
                  {cat.namePl}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}